import icons from '../assets/img/iconos'

// export const barrios = [
//     "Candioti Norte",
//     "Fomento 9 de Julio",
//     "General Alvear",
//     "Mariano Comas",
//     "Sargento Cabral",
// ]

// export const residencia = [
//     "Menor a 5 años",
//     "Entre 5 y 10 años",
//     "Entre 10 y 20 años",
//     "Mayor a 20 años",
// ]

// export const motivo = [
//     "Vivo en el barrio",
//     "Trabajo en el barrio",
//     "Tengo familiares en el barrio",
//     "Otros",
// ]

export const questions2 = [
    {
        title: "¿Cómo considera que es la conexión de las calles en el barrio?",
        titleFull: "Conexiones con las calles",
        icon: icons.i1,
        sections: [
            {
                title: "Dentro del barrio",
                name: "dentro_del_barrio",
                fieldType: 'radio',
                mapEnabled: 'Malo',
                options: [
                    "Bueno",
                    "Malo"
                ]
            },
            {
                title: "Con barrios vecinos",
                name: "con_barrios_vecinos",
                fieldType: 'radio',
                mapEnabled: 'Malo',
                options: [
                    "Bueno",
                    "Malo"
                ]
            }
        ]
    },
    {
        title: "¿Cómo son las veredas?",
        titleFull: "Veredas",
        icon: icons.i2,
        sections: [
            {
                title: "Estado",
                name: 'veredas_estado',
                fieldType: 'radio',
                mapEnabled: 'Malo|Regular',
                options: [
                    "Bueno",
                    "Malo",
                    "Regular"
                ]
            },
            {
                title: "Extensión",
                name: 'veredas_extension',
                fieldType: 'radio',
                options: [
                    "Anchas",
                    "Normales",
                    "Angostas"
                ]
            },
            {
                title: "Material",
                name: 'veredas_material',
                fieldType: 'radio',
                mapEnabled: 'Ninguna',
                options: [
                    "Mosaicos",
                    "Losetas",
                    "Ninguna"
                ]
            },
            {
                title: "Césped",
                name: 'veredas_cesped',
                fieldType: 'radio',
                mapEnabled: 'Sin césped',
                options: [
                    "Con césped",
                    "Sin césped",
                    "Parcialmente con césped"
                ]
            },
            {
                title: "Desniveles",
                name: 'veredas_desniveles',
                fieldType: 'radio',
                mapEnabled: 'Con desniveles',
                options: [
                    "Con desniveles",
                    "Sin desniveles"
                ]
            }
        ]
    },
    {
        title: "¿Existen pasajes internos en las manzanas?",
        titleFull: "Pasajes internos",
        icon: icons.i3,
        sections: [
            {
                title: "",
                name: 'pasajes_internos',
                fieldType: 'radio',
                mapEnabled: 'Sí',
                options: [
                    "Sí",  // Al cliquear "Si" se despliega: Situación de los pasajes: Conflictivos / No Conflictivos
                    "No",
                    "NS/NC"
                ]
            }
        ]
    },
    {
        title: "¿Cómo considera el impacto del sistema ferroviario en el barrio?",
        titleFull: "Impacto ferroviario",
        icon: icons.i4,
        sections: [
            {
                title: "Cortan las calles",
                name: 'ferroviario_cortan',
                fieldType: 'radio',
                mapEnabled: 'Sí',
                options: [
                    "Sí",
                    "No"
                ]
            },
            {
                title: "Degrada el entorno",
                name: 'ferroviario_degrada',
                fieldType: 'radio',
                mapEnabled: 'Sí',
                options: [
                    "Sí",
                    "No"
                ]
            },
            {
                title: "Recuperados como espacios verdes",
                name: 'ferroviario_recuperado_verde',
                fieldType: 'radio',
                options: [
                    "Sí",
                    "No"
                ]
            },
            {
                title: "Recuperados para uso comunitario",
                name: 'ferroviario_recuperado_comunitario',
                fieldType: 'radio',
                options: [
                    "Sí",
                    "No"
                ]
            }
        ]
    }
]

export const questions3 = [
    {
        title: "Respecto de los lotes baldíos",
        titleFull: "Lotes baldíos",
        icon: icons.i5,
        sections: [
            {
                title: "Cantidad",
                name: "baldios_cantidad",
                fieldType: 'radio',
                mapEnabled: 'Muchos',
                options: [
                    "Muchos",
                    "Pocos"
                ]
            },
            {
                title: "Estado",
                name: "baldios_estado",
                fieldType: 'radio',
                mapEnabled: 'Abandonados',
                options: [
                    "Abandonados",
                    "Limpios"
                ]
            }
        ]
    },
    {
        title: "Respecto de la calidad de las viviendas",
        titleFull: "Calidad viviendas",
        icon: icons.i6,
        sections: [
            {
                title: "",
                name: "calidad_vivienda",
                fieldType: 'radio',
                options: [
                    "Buena",
                    "Regular",
                    "Mala",
                ]
            }
        ]
    },
    {
        title: "Respecto de la presencia de edificios para usos distintos al de vivienda",
        titleFull: "Presencia edificios",
        icon: icons.i7,
        sections: [
            {
                title: "",
                name: "presencia_edificios",
                fieldType: 'checkbox',
                options: [
                    "Industria",
                    "Comercio",
                    "Instituciones",
                    "Otros",
                ]
            }
        ]
    },
    {
        title: "¿Considera que en su barrio hay algún tipo de construcción que se destaque?",
        titleFull: "Construcción destacada",
        icon: icons.i8,
        sections: [
            {
                title: "",
                name: "construccion_destacada",
                fieldType: 'radio',
                mapEnabled: 'Sí',
                options: [
                    "Sí",
                    "No"
                ]
            },
        ]
    },
    {
        title: "¿Existe en su barrio algún asentamiento precario tipo villa miseria?",
        titleFull: "Asentamiento precario",
        icon: icons.i9,
        sections: [
            {
                title: "",
                name: "asentamiento_villa_miseria",
                fieldType: 'radio',
                mapEnabled: 'Sí',
                options: [
                    "Sí",
                    "No"
                ]
            },
        ]
    }
]

export const questions4 = [
    {
        title: "Respecto de los espacios verdes",
        titleFull: "Espacios verdes",
        icon: icons.i10,
        sections: [
            {
                title: "Cantidad",
                name: "espacios_verdes_cantidad",
                fieldType: 'radio',
                options: [
                    "Suficientes",
                    "Insuficientes"
                ]
            },
            {
                title: "Estado",
                name: "espacios_verdes_estado",
                fieldType: 'radio',
                mapEnabled: 'Malo|Regular',
                options: [
                    "Bueno",
                    "Malo",
                    "Regular"
                ]
            }
        ]
    },
    {
        title: "Respecto del arbolado público",
        titleFull: "Arbolado público",
        icon: icons.i11,
        sections: [
            {
                title: "Cantidad",
                name: "arbolado_cantidad",
                fieldType: 'radio',
                mapEnabled: 'Insuficientes',
                options: [
                    "Suficientes",
                    "Insuficientes"
                ]
            },
            {
                title: "Estado",
                name: "arbolado_estado",
                fieldType: 'radio',
                mapEnabled: 'Malo|Regular',
                options: [
                    "Bueno",
                    "Malo",
                    "Regular"
                ]
            },
            {
                title: "Conflicto",
                name: "arbolado_conflicto",
                fieldType: 'radio',
                mapEnabled: 'Genera',
                options: [
                    "Genera",
                    "No Genera"
                ]
            }
        ]
    }
]

export const questions5 = [
    {
        title: "Respecto de la red de agua potable",
        titleFull: "Red agua potable",
        icon: icons.i12,
        sections: [
            {
                title: "Estado de la red",
                name: "red_agua_estado",
                fieldType: 'radio',
                mapEnabled: 'Malo|Regular|No Existe',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                    "No Existe",
                ]
            }
        ]
    },
    {
        title: "Respecto de los desagües pluviales",
        titleFull: "Desagües pluviales",
        icon: icons.i13,
        sections: [
            {
                title: "Estado de la red",
                name: "desagues_pluviales_estado",
                fieldType: 'radio',
                mapEnabled: 'Malo|No Existe',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                    "No Existe",
                ]
            }
        ]
    },
    {
        title: "Respecto de los desagües cloacales",
        titleFull: "Desagües cloacales",
        icon: icons.i14,
        sections: [
            {
                title: "Estado de la red",
                name: "desagues_cloacales_estado",
                fieldType: 'radio',
                mapEnabled: 'Malo|Regular',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                    "No Existe",
                ]
            }
        ]
    },
    {
        title: "Respecto de la red de gas natural",
        titleFull: "Red gas natural",
        icon: icons.i15,
        sections: [
            {
                title: "Estado de la red",
                name: "red_gas_estado",
                fieldType: 'radio',
                mapEnabled: 'Malo|Regular',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                    "No Existe",
                ]
            }
        ]
    },
    {
        title: "Respecto del pavimento de las calles",
        titleFull: "Pavimento",
        icon: icons.i16,
        sections: [
            {
                title: "Estado",
                name: "pavimento_estado",
                fieldType: 'radio',
                mapEnabled: 'Regular|Malo|No Existe',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                    "No Existe",
                ]
            }
        ]
    }
]

export const questions6 = [
    {
        title: "Barrido y limpieza",
        titleFull: "Barrido y limpieza",
        icon: icons.i17,
        sections: [
            {
                title: "",
                name: "barrido_estado",
                fieldType: 'radio',
                mapEnabled: 'Malo|Regular',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                ]
            }
        ]
    },
    {
        title: "Recolección de basura",
        titleFull: "Recolección de basura",
        icon: icons.i18,
        sections: [
            {
                title: "",
                name: "recoleccion_basura_estado",
                fieldType: 'radio',
                mapEnabled: 'Regular|Malo',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                ]
            }
        ]
    },
    {
        title: "Mantenimiento de espacios verdes",
        titleFull: "Mantenimiento de espacios verdes",
        icon: icons.i19,
        sections: [
            {
                title: "Estado",
                name: "espacios_verdes_estado",
                fieldType: 'radio',
                mapEnabled: 'Malo|Regular',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                ]
            },
            {
                title: "Mantenimiento y poda",
                name: "espacios_verdes_mantenimiento",
                fieldType: 'radio',
                // mapEnabled: 'Malo|Regular',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                ]
            }
        ]
    },
    {
        title: "Transporte público",
        titleFull: "Transporte público",
        icon: icons.i20,
        sections: [
            {
                title: "",
                name: "transporte_estado",
                fieldType: 'radio',
                mapEnabled: 'Malo',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                ]
            }
        ]
    },
    {
        title: "Iluminación pública",
        titleFull: "Iluminación pública",
        icon: icons.i21,
        sections: [
            {
                title: "",
                name: "iluminación_estado",
                fieldType: 'radio',
                mapEnabled: 'Malo|Regular',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                ]
            }
        ]
    },
    {
        title: "Semáforos",
        titleFull: "Semáforos",
        icon: icons.i22,
        sections: [
            {
                title: "Cantidad",
                name: "semaforos_cantidad",
                fieldType: 'radio',
                options: [
                    "Suficientes",
                    "Insuficientes",
                ]
            },
            {
                title: "Ubicación",
                name: "semaforos_ubicacion",
                fieldType: 'radio',
                mapEnabled: 'Mala',
                options: [
                    "Buena",
                    "Mala",
                ]
            }
        ]
    },
    {
        title: "Servicios de TV por cable",
        titleFull: "TV por cable",
        icon: icons.i23,
        sections: [
            {
                title: "",
                name: "tv_estado",
                fieldType: 'radio',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                ]
            }
        ]
    },
    {
        title: "Servicio de Internet",
        titleFull: "Internet",
        icon: icons.i24,
        sections: [
            {
                title: "",
                name: "internet_cantidad",
                fieldType: 'radio',
                options: [
                    "Suficientes",
                    "Insuficientes",
                ]
            }
        ]
    },
    {
        title: "Servicio de telefonía móvil",
        titleFull: "Telefonía móvil",
        icon: icons.i25,
        sections: [
            {
                title: "",
                name: "celular_estado",
                fieldType: 'radio',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                ]
            }
        ]
    },
    {
        title: "Alarmas Comunitarias",
        titleFull: "Alarmas Comunitarias",
        // icon: icons.i25,
        sections: [
            {
                title: "",
                name: "alarmas_comunitarias_estado",
                fieldType: 'radio',
                options: [
                    "Buena",
                    "Regular",
                    "Mala",
                    "No existe",
                ]
            }
        ]
    }
]

export const questions7 = [
    {
        title: "Respecto de los centros educativos",
        titleFull: "Centros educativos",
        icon: icons.i26,
        sections: [
            {
                title: "",
                name: "centros_educativos_cantidad",
                fieldType: 'radio',
                options: [
                    "Suficientes",
                    "Insuficientes",
                    "Inexistentes",
                ]
            },
            {
                title: "Estado",
                name: "centros_educativos_calidad",
                fieldType: 'radio',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                    "NS/NC",
                ]
            }
        ]
    },
    {
        title: "Respecto de los centros de salud",
        titleFull: "Centros de salud",
        icon: icons.i27,
        sections: [
            {
                title: "",
                name: "centros_salud_cantidad",
                fieldType: 'radio',
                options: [
                    "Suficientes",
                    "Insuficientes",
                    "Inexistentes",
                ]
            },
            {
                title: "Estado",
                name: "centros_salud_calidad",
                fieldType: 'radio',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                    "NS/NC",
                ]
            }
        ]
    },
    {
        title: "Respecto de los centros recreativos/deportivos",
        titleFull: "Centros recretivos/deportivos",
        icon: icons.i28,
        sections: [
            {
                title: "",
                name: "centros_deportivos_cantidad",
                fieldType: 'radio',
                options: [
                    "Suficientes",
                    "Insuficientes",
                    "Inexistentes",
                ]
            },
            {
                title: "Estado",
                name: "centros_deportivos_calidad",
                fieldType: 'radio',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                    "NS/NC",
                ]
            }
        ]
    },
    {
        title: "Respecto de los centros culturales",
        titleFull: "Centros culturales",
        icon: icons.i29,
        sections: [
            {
                title: "",
                name: "centros_culturales_cantidad",
                fieldType: 'radio',
                options: [
                    "Suficientes",
                    "Insuficientes",
                    "Inexistentes",
                ]
            },
            {
                title: "Estado",
                name: "centros_culturales_calidad",
                fieldType: 'radio',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                    "NS/NC",
                ]
            }
        ]
    },
]

export const questions8 = [
    {
        title: "¿Cómo considera los comercios y servicios de su barrio?",
        titleFull: "Comercios y servicios",
        icon: icons.i30,
        sections: [
            {
                title: "Cantidad",
                name: "comercios_cantidad",
                fieldType: 'radio',
                options: [
                    "Suficientes",
                    "Insuficientes",
                ]
            },
            {
                title: "Calidad",
                name: "comercios_calidad",
                fieldType: 'radio',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                ]
            }
        ]
    },
]

export const questions9 = [
    {
        title: "¿Detecta actividad industrial en su barrio?",
        titleFull: "Actividad industrial",
        icon: icons.i31,
        sections: [
            {
                title: "",
                name: "actividad_industrial_presencia",
                fieldType: 'radio',
                options: [
                    "Si",
                    "No",
                ]
            },
        ]
    },
    {
        title: "¿Piensa que genera problemas?",
        titleFull: "Actividad industrial genera problemas",
        icon: icons.i32,
        sections: [
            {
                title: "",
                name: "actividad_industrial_problemas",
                fieldType: 'radio',
                mapEnabled: 'Si',
                options: [
                    "Si",
                    "No",
                ]
            },
        ]
    },
]

export const questions10 = [
    {
        title: "La población es...",
        titleFull: "Población",
        icon: icons.i33,
        sections: [
            {
                title: "",
                name: "poblacion_tipo",
                fieldType: 'radio',
                options: [
                    "Similar",
                    "Variada",
                ]
            },
        ]
    },
    {
        title: "¿Cómo es la relación con los vecinos del barrio?",
        titleFull: "Relación con vecinos",
        icon: icons.i34,
        sections: [
            {
                title: "",
                name: "relacion_vecinos_estado",
                fieldType: 'radio',
                options: [
                    "Bueno",
                    "Regular",
                    "Malo",
                    "Indiferente",
                ]
            },
        ]
    },
    {
        title: "¿Comparte actividades con sus vecinos?",
        titleFull: "Comparte actividades con vecinos",
        icon: icons.i35,
        sections: [
            {
                title: "",
                name: "relacion_vecinos_actividades",
                fieldType: 'radio',
                options: [
                    "Si",
                    "No",
                ]
            },
        ]
    },
    {
        title: "¿Piensa que genera problemas?",
        titleFull: "Relaciones problemáticas con vecinos",
        icon: icons.i36,
        sections: [
            {
                title: "",
                name: "relacion_vecinos_problemas",
                fieldType: 'radio',
                options: [
                    "Si",
                    "No",
                ]
            },
        ]
    },
    {
        title: "¿Son solidarios los vecinos?",
        titleFull: "Vecinos solidarios",
        icon: icons.i37,
        sections: [
            {
                title: "",
                name: "relacion_vecinos_solidaridad",
                fieldType: 'radio',
                options: [
                    "Si",
                    "No",
                    "Relativamente",
                ]
            },
        ]
    },
    {
        title: "¿Comparte intereses barriales con sus vecinos?",
        titleFull: "Comparte intereses barriales con sus vecinos",
        icon: icons.i38,
        sections: [
            {
                title: "",
                name: "relacion_vecinos_intereses",
                fieldType: 'radio',
                options: [
                    "Si",
                    "No",
                    "Relativamente",
                ]
            },
        ]
    },
]

export const questions11 = [
    {
        title: "¿Cómo es el tránsito vehicular de su barrio?",
        titleFull: "Tránsito vehicular",
        icon: icons.i39,
        sections: [
            {
                title: "",
                name: "transito_vehicular_cantidad",
                fieldType: 'radio',
                options: [
                    "Intenso",
                    "Normal",
                    "Escaso",
                ]
            },
            {
                title: "Característica",
                name: "transito_vehicular_problemas",
                fieldType: 'radio',
                mapEnabled: 'Peligroso',
                options: [
                    "Peligroso",
                    "Seguro",
                ]
            },
        ]
    },
    {
        title: "¿Existe concentración de vehículos en ciertas horas del día?",
        titleFull: "Concentración vehicular",
        icon: icons.i40,
        sections: [
            {
                title: "",
                name: "concentracion_vehicular",
                fieldType: 'radio',
                mapEnabled: 'Si',
                options: [
                    "Si",
                    "No",
                ]
            },
        ]
    },
    {
        title: "Cruces de calles conflictivas y peligrosas",
        titleFull: "Calles conflictivas y peligrosas",
        icon: icons.i41,
        sections: [
            {
                title: "",
                name: "cruce_calles_conflictivos_cantidad",
                fieldType: 'radio',
                mapEnabled: 'Muchos',
                options: [
                    "Muchos",
                    "Moderados",
                    "Pocos",
                ]
            },
        ]
    },
    {
        title: "Tránsito pesado",
        titleFull: "Tránsito pesado",
        icon: icons.i42,
        sections: [
            {
                title: "",
                name: "transito_pesado_cantidad",
                fieldType: 'radio',
                options: [
                    "Intenso",
                    "Normal",
                    "Escaso",
                ]
            },
            {
                title: "Característica",
                name: "transito_pesado_tipo",
                fieldType: 'radio',
                mapEnabled: 'Peligroso',
                options: [
                    "Peligroso",
                    "Seguro",
                ]
            },
        ]
    },
    {
        title: "Circulación en bicicletas",
        titleFull: "Circulación de bicicletas",
        icon: icons.i43,
        sections: [
            {
                title: "",
                name: "transito_bicicletas_cantidad",
                fieldType: 'radio',
                options: [
                    "Intenso",
                    "Normal",
                    "Escaso",
                ]
            },
            {
                title: "Característica",
                name: "transito_bicicletas_tipo",
                fieldType: 'radio',
                mapEnabled: 'Peligroso',
                options: [
                    "Peligroso",
                    "Seguro",
                ]
            },
        ]
    },
    {
        title: "Circulación en motociclos",
        titleFull: "Circulación de motociclos",
        icon: icons.i44,
        sections: [
            {
                title: "",
                name: "transito_motociclos_cantidad",
                fieldType: 'radio',
                options: [
                    "Intenso",
                    "Normal",
                    "Escaso",
                ]
            },
            {
                title: "Característica",
                name: "transito_motociclos_tipo",
                fieldType: 'radio',
                mapEnabled: 'Peligroso',
                options: [
                    "Peligroso",
                    "Seguro",
                ]
            },
        ]
    },
    {
        title: "Concentración peatonal",
        titleFull: "Concentración peatonal",
        icon: icons.i45,
        sections: [
            {
                title: "",
                name: "transito_peatonal_cantidad",
                fieldType: 'radio',
                options: [
                    "Intenso",
                    "Normal",
                    "Escaso",
                ]
            },
            {
                title: "Característica",
                name: "transito_peatonal_tipo",
                fieldType: 'radio',
                mapEnabled: 'Peligroso',
                options: [
                    "Peligroso",
                    "Seguro",
                ]
            },
        ]
    },
    {
        title: "¿Hay zonas conflictivas por el estacionamiento de vehículos?",
        titleFull: "Zonas conflictivas por estacionamiento vehicular",
        icon: icons.i46,
        sections: [
            {
                title: "",
                name: "estacionamiento_zonas_conflictivas",
                fieldType: 'radio',
                mapEnabled: 'Si',
                options: [
                    "Si",
                    "No",
                    "NS/NC",
                ]
            },
        ]
    },
]

export const questions12 = [
    {
        title: "Uso de espacio público por adultos mayores",
        icon: icons.i47,
        sections: [
            {
                title: "",
                name: "uso_espacio_publico_mayores",
                fieldType: 'radio',
                options: [
                    "Intenso",
                    "Moderado",
                    "Escaso",
                ]
            },
        ]
    },
    {
        title: "Uso de espacio público por adultos jóvenes",
        icon: icons.i48,
        sections: [
            {
                title: "",
                name: "uso_espacio_publico_jovenes",
                fieldType: 'radio',
                options: [
                    "Intenso",
                    "Moderado",
                    "Escaso",
                ]
            },
        ]
    },
    {
        title: "Uso de espacio público por adolescentes",
        icon: icons.i49,
        sections: [
            {
                title: "",
                name: "uso_espacio_publico_adolescentes",
                fieldType: 'radio',
                options: [
                    "Intenso",
                    "Moderado",
                    "Escaso",
                ]
            },
        ]
    },
    {
        title: "Uso de espacio público por los niños",
        icon: icons.i50,
        sections: [
            {
                title: "",
                name: "uso_espacio_publico_ninos",
                fieldType: 'radio',
                options: [
                    "Intenso",
                    "Moderado",
                    "Escaso",
                ]
            },
        ]
    },
    {
        title: "¿Existen fiestas populares en su barrio?",
        icon: icons.i51,
        sections: [
            {
                title: "",
                name: "fiestas_populares_existencia",
                fieldType: 'radio',
                options: [
                    "Si",
                    "No",
                    "NS/NC",
                ]
            },
        ]
    },
    {
        title: "¿Cuál cree que es el nivel de inseguridad en su barrio? ",
        icon: icons.i52,
        sections: [
            {
                title: "",
                name: "inseguridad_nivel",
                fieldType: 'radio',
                options: [
                    "Alto",
                    "Moderado",
                    "Bajo",
                ]
            },
            {
                title: "Característica",
                name: "inseguridad_ubicacion",
                fieldType: 'radio',
                mapEnabled: 'Localizada en sitios particulares',
                options: [
                    "Generalizado en todo el barrio",
                    "Localizada en sitios particulares",
                ]
            },
            {
                title: "Tipo de situaciones de inseguridad y socialmente conflictivas",
                name: "inseguridad_tipo",
                fieldType: 'checkbox',
                options: [
                    'Robos y arrebatos callejeros',
                    'Robos con armas en comercios, oficinas, locales públicos y semi-públicos',
                    'Motochorros',
                    'Venta de droga',
                    'Prostitución',
                    'Usurpación de propiedades privadas',
                    'Usurpación de espacio público',
                ]
            },
        ]
    },
    {
        title: "¿Existen edificios o instalaciones especiales para uso público y/o semipúblico en el barrio? ",
        icon: icons.i53,
        sections: [
            {
                title: "",
                name: "instalaciones_publicas",
                fieldType: 'radio',
                options: [
                    "Si",
                    "No",
                ],
                suboptions: [
                    {
                        trigger: "Si",
                        name: "instalaciones_publicas_uso",
                        fieldType: 'radio',
                        options: [
                            "Usados por Adultos Mayores",
                            "Usados por Adultos Jóvenes",
                            "Usados por Adolescentes",
                            "Usados por Niños",
                        ]
                    }
                ]
            },
        ]
    },
]

export const questions13 = [
    {
        title: "¿Existe algún tipo de contaminación preocupante?",
        icon: icons.i54,
        sections: [
            {
                title: "",
                name: "contaminacion_existencia",
                fieldType: 'radio',
                mapEnabled: 'Si',
                options: [
                    "Si",
                    "No",
                ],
                suboptions: [
                    {
                        trigger: "Si",
                        name: "contaminacion_si_tipo",
                        fieldType: 'checkbox',
                        options: [
                            "Aire",
                            "Agua",
                            "Visual",
                            "Sonora",
                        ]
                    },
                    {
                        trigger: "No",
                        name: "contaminacion_no_tipo",
                        fieldType: 'radio',
                        options: [
                            "Abundante",
                            "Moderada",
                            "Escasa",
                        ]
                    },
                ]
            },
            {
                title: "Tipo",
                name: "contaminacion_tipo",
                fieldType: 'checkbox',
                options: [
                    'Aire contaminado',
                    'Aguas servidas',
                    'Ruidos molestos',
                    'Visual',
                ]
            },
        ]
    },
    {
        title: "¿Existe basura dispersa en la vía pública?",
        icon: icons.i55,
        sections: [
            {
                title: "",
                name: "basura_via_publica",
                fieldType: 'radio',
                mapEnabled: 'Si',
                options: [
                    "Si",
                    "No",
                ]
            },
        ]
    },
]

export const questions14 = [
    {
        title: "¿Existen respuestas a las demandas de los vecinos?",
        icon: icons.i56,
        sections: [
            {
                title: "",
                name: "respuesta_demandas",
                fieldType: 'radio',
                options: [
                    "Si",
                    "No",
                    "Parcialmente"
                ],
                suboptions: [
                    {
                        trigger: "Si",
                        name: "respuesta_demandas_tipo",
                        fieldType: 'radio',
                        options: [
                            "Buena",
                            "Regular",
                            "Mala",
                            "NS/NC",
                        ]
                    }
                ]
            },
        ]
    },
    {
        title: "¿Existe diálogo con las instituciones barriales?",
        icon: icons.i57,
        sections: [
            {
                title: "",
                name: "dialogo_insituciones_barriales",
                fieldType: 'radio',
                options: [
                    "Si",
                    "No",
                    "Parcialmente"
                ],
                suboptions: {
                    trigger: "Si",
                    name: "dialogo_insituciones_barriales_tipo",
                    fieldType: 'radio',
                    options: [
                        "Buena",
                        "Regular",
                        "Mala",
                        "NS/NC"
                    ]
                }
            },
        ]
    },
]

export const questions15 = [
    {
        title: "¿Cuál es su nivel de satisfacción con el barrio?",
        icon: icons.i58,
        sections: [
            {
                title: "Nivel de infraestructura",
                subtitle: "(agua por red, gas por red, red cloacal, red de desagües)",
                name: "conformidad_nivel_infraestructura",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            },
            {
                title: "Estado de las calles",
                name: "conformidad_estado_calles",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            },
            {
                title: "Servicios Públicos",
                subtitle: "(iluminación, semaforización, barrido, limpieza, recolección de residuos, TV e Internet por cable)",
                name: "conformidad_servicios_publicos",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            },
            {
                title: "Instituciones Públicas y Privadas de Servicios",
                subtitle: "(educación, salud, seguridad, recreación, deporte, culto)",
                name: "conformidad_instituciones_servicios",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            },
            {
                title: "Espacios Verdes del barrio",
                name: "conformidad_espacios_verdes",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            },
            {
                title: "Construcciones del barrio",
                name: "conformidad_construcciones",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            },
            {
                title: "Comunicación del barrio con el resto de la ciudad",
                name: "conformidad_comunicacion_barrio",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            },
            {
                title: "Población del barrio",
                name: "conformidad_poblacion_barrio",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            },
            {
                title: "Gente que vive en el barrio",
                name: "conformidad_gente_barrio",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            },
            {
                title: "Comercios del barrio",
                name: "conformidad_comercios_barrio",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            },
            {
                title: "Nivel de mejora y progreso que desea para el barrio",
                name: "conformidad_mejora_barrio",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            },
            {
                title: "¿Está conforme con su vivienda?",
                name: "conformidad_vivienda_propia",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            },
            {
                title: "¿Se identifica con el barrio y está a gusto que lo identifiquen con él?",
                name: "conformidad_identificacion",
                fieldType: 'radio',
                options: [
                    "Conforme",
                    "Disconforme",
                    "Relativamente conforme"
                ]
            }
        ]
    }
]

export const questions16 = [
    {
        title: "Respecto de las calles, avenidas, pasajes, cortadas:",
        detail: "¿cuáles son para Ud. relevantes dentro del barrio?",
        icon: icons.i59,
        sections: [
            {
                title: "",
                placeholder: 'Respuesta',
                fieldType: 'input',
                type: 'string',
                repeat: 1,
                name: "calles_relevante",
            },
            {
                name: "calles_relevante_check",
                title: "",
                options: [
                    "En toda su extensión",
                    "En el tramo entre" // Al cliquear "En el tramo entre" se habilita un campo para poder escribir cuales son los tramos
                ]
            }
        ]
    },
    {
        title: 'Respecto de las plazas, parques, plazoletas y otro tipo de espacios verdes:',
        detail: '¿cuáles son para Ud. relevantes dentro del barrio?',
        icon: icons.i60,
        sections: [
            {
                title: "",
                placeholder: 'Respuesta',
                fieldType: 'input',
                type: 'string',
                repeat: 5,
                name: "espacios_verdes_relevante",
            }
        ]
    },
    {
        title: 'Respecto de la arquitectura:',
        detail: '¿qué edificios en particular tienen relevancia para Ud. dentro del barrio?',
        icon: icons.i61,
        sections: [
            {
                title: "",
                placeholder: 'Respuesta',
                fieldType: 'input',
                type: 'string',
                repeat: 5,
                name: "arquitectura_relevante",
            }
        ]
    }
]

// questions17 doesn't exists

export const questions18 = [
    {
        title: "Género",
        sections: [
            {
                title: "",
                name: "personal_genero",
                fieldType: 'radio',
                options: [
                    "Mujer",
                    "Hombre"
                ]
            }
        ]
    },
    {
        title: "Edad",
        sections: [
            {
                title: "",
                name: "personal_edad",
                fieldType: 'radio',
                options: [
                    "13 a 19 años",
                    "20 a 39 años",
                    "40 a 69 años",
                    "Más de 70 años"
                ]
            }
        ]
    },
    {
        title: "Estudios",
        sections: [
            {
                title: "",
                name: "personal_estudios_tipo",
                fieldType: 'radio',
                options: [
                    "Primario",
                    "Secundario",
                    "Superior/Universitario"
                ]
            },
            {
                title: "",
                name: "personal_estudios_completo",
                fieldType: 'radio',
                options: [
                    "Completo",
                    "Incompleto"
                ]
            }
        ]
    },
    {
        title: "Ocupacion",
        sections: [
            {
                title: "",
                name: "personal_ocupacion",
                fieldType: 'radio',
                options: [
                    "Empleado",
                    "Desempleado",
                    "Desocupado"
                ]
            }
        ]
    },
]

export const questions19 = [
    {
        title: "¿Cuál es su nivel de interés por los problemas barriales?",
        icon: icons.a,
        sections: [
            {
                title: "",
                name: "personal_nivel_interes",
                fieldType: 'radio',
                options: [
                    "Nulo",
                    "Bajo",
                    "Medio",
                    "Alto"
                ]
            }
        ]
    },
    {
        title: "¿Cuál es su nivel de compromiso con otros vecinos o instituciones para trabajar por los problemas barriales?",
        icon: icons.b,
        sections: [
            {
                title: "",
                name: "personal_nivel_compromiso",
                fieldType: 'radio',
                options: [
                    "Nulo",
                    "Bajo",
                    "Medio",
                    "Alto"
                ]
            }
        ]
    }
]
